import React from "react";
import CountUp from "react-countup";

function WorklistCharts({ worklistDetail, isLoading }) {
  return (
    <>
      <div className="col-xl-4">
        {isLoading && (
          <div className="card card-flush pt-10 pb-10">
            <div className="row">
              <div className="col-12 text-center">
                <div className="spinner-border h-30px w-30px text-gray-400" />
              </div>
            </div>
          </div>
        )}

        {!isLoading && (
          <div className="card card-flush mb-5 chart-overall-status">
            <div className="card-header py-4">
              <p className="card-title align-items-start flex-column">
                <span className="fw-bold h4">Charts</span>
                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                  Overall status of charts in this worklist
                </span>
              </p>
            </div>
            <div className="card-body pt-6 pb-6">
              <div className="row p-0 ">
                <div className="col-4">
                  <div className="border border-dashed border-gray-300 text-center  rounded py-2">
                    <span
                      className="fs-2hx fw-bold text-gray-900 counted"
                      data-kt-countup="true"
                      data-kt-countup-value={worklistDetail?.totalCharts}
                      data-kt-initialized={1}
                    >
                      <CountUp
                        start={0}
                        end={worklistDetail?.totalCharts}
                      ></CountUp>
                    </span>
                    <span className="fs-4 fw-semibold text-success d-block">
                      Total Charts
                    </span>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border border-dashed border-gray-300 text-center rounded py-2">
                    <span
                      className="fs-2hx fw-bold text-gray-900 counted"
                      data-kt-countup="true"
                      data-kt-countup-value={worklistDetail?.allocatedCharts}
                      data-kt-initialized={1}
                    >
                      <CountUp
                        start={0}
                        end={worklistDetail?.allocatedCharts}
                      ></CountUp>
                    </span>
                    <span className="fs-4 fw-semibold text-primary d-block">
                      {" "}
                      Allocated
                    </span>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border border-dashed border-gray-300 text-center rounded py-2">
                    <span
                      className="fs-2hx fw-bold text-gray-900 counted"
                      data-kt-countup="true"
                      data-kt-countup-value={worklistDetail?.unallocatedCharts}
                      data-kt-initialized={1}
                    >
                      <CountUp
                        start={0}
                        end={worklistDetail?.unallocatedCharts}
                      ></CountUp>
                    </span>
                    <span className="fs-4 fw-semibold text-info d-block">
                      Unallocated
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default WorklistCharts;
